const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB;

const hasValue = (value) => value !== null && value !== undefined && value !== "";

export const garrisonLinkUrl = {
    dispatch: (id) => hasValue(id) ? {dev: `${API_DESPACHO_WEB}/dispatch/form/${id}`} : null,
    attendance: (id) => hasValue(id) ? {dev: `${API_DESPACHO_WEB}/attendance/form/${id}`} : null,
    bo: (occurrenceNumber) => {
        if (!hasValue(occurrenceNumber)) return null;
        const code = String(occurrenceNumber).replace("/", "-");
        return {dev: `/bo/redirect/${code}`};
    },
};

export const INTENDED_FUNCTION_FIXED_LOCATION = "FIXED_LOCATION";

export const INSPECTION_OPTIONS = [
    {value: "NOTHING_NEW", label: "Regular"},
    {value: "DAMAGED", label: "Danificado"},
    {value: "MISSING", label: "Ausente"},
    {value: "IRREGULAR", label: "Irregular"},
];

export const capitalizeFirstLetter = (text = "") =>
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

export const mapLeaders = (list = []) => list.map(item => ({value: item.id, label: item.namewar}));

export const mapTeams = (list = []) => list.map(item => (typeof item === "string"
    ? {value: item, label: item}
    : {value: item.value ?? item.name ?? item.id, label: item.label ?? item.name}));

export const mapIntendedFunctions = (list = []) => list.map(item => ({value: item.key, label: item.name}));

export const mapPlaces = (list = []) => list.map(item => ({value: item.name, label: item.name, placeId: item.id}));

export const mapSectors = (list = []) => list.map(item => (typeof item === "string"
    ? {value: item, label: item}
    : {value: item.value ?? item.name, label: item.label ?? item.name}));

export const mapAnimalOptions = (list = []) => list.map(item => ({value: item.id, label: item.name}));

export const mapContingentOptions = (list = []) => list.map(item => ({
    value: item.id,
    label: item.namewar,
    cnhWarning: item.cnhWarning ?? null,
    cnhWarningText: item.cnhWarningText ?? "",
}));

export const isIntegrantRequired = (integrant) =>
    Boolean(integrant?.mandatory);

const buildCompositionPayload = (rows) => {
    const composition = [];

    rows.forEach(row => {
        const integrants = (row.integrants ?? [])
            .filter(integrant => integrant.contingentId !== "" && integrant.contingentId != null)
            .map(integrant => ({
                contingent: {id: integrant.contingentId},
                position: integrant.position,
                id: integrant.integrantId,
            }));

        if (!integrants.length) return;

        composition.push({
            integrants,
            compositionId: row.compositionId,
            type: row.vehicleId ? "WITH_VEHICLE" : "WITHOUT_VEHICLE",
            vehicleId: row.vehicleId ? row.vehicleId : null,
            initialMileage: row.initialMileage !== "" && row.initialMileage != null ? row.initialMileage : null,
            finalMileage: row.finalMileage !== "" && row.finalMileage != null ? row.finalMileage : null,
        });
    });

    return composition;
};

export const buildGarrisonModel = ({state, retroactive, mode, compositionRows, animals, scheduleIds, actions}) => {
    const finalized = state.finalized;

    let id;
    if (mode === "edit") id = state.id;
    else if (mode === "copy") id = undefined;
    else id = "";

    return {
        id: id != null ? id : null,
        retroactive,
        systemUpdate: state.systemUpdate || null,
        start: state.start || null,
        end: state.end ? (finalized ? state.end : null) : null,
        status: !finalized,
        finalized,
        team: state.team || null,
        intendedFunction: state.intendedFunction || null,
        sectors: state.sectors ?? [],
        place: state.place || null,
        initialObservation: state.initialObservation || null,
        finalObservation: state.finalObservation || null,
        addNew: actions.addNew,
        addNewHome: actions.addNewHome,
        addNewAndCopy: actions.addNewAndCopy,
        composition: buildCompositionPayload(compositionRows),
        animals,
        isCopy: mode === "copy",
        leaderId: state.leaderId || null,
        scheduleIds: scheduleIds.length > 0 ? scheduleIds : [],
        schedulesJustification: state.schedulesJustification || null,
    };
};

export const buildFixedLocationInspection = (inspectionRows = []) => ({
    data: inspectionRows
        .filter(row => row.answer !== "" && row.answer != null)
        .map(row => ({item: row.item, answer: row.answer})),
});
